import styled from 'styled-components';
import { colors } from '../../assets/colors/index.tsx';

export const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${colors.secondary} 0%, ${colors.quinary} 100%);
  /* Counteract GeneralWrapper padding to maintain full-screen appearance */
  margin: 0 -2em;
  @media (min-width: 1024px) {
    margin: 0 -7em;
  }
`;

export const NotFoundCard = styled.div`
  background: ${colors.secondary};
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 4rem 3rem;
  width: 100%;
  max-width: 600px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 2rem;
    margin: 1rem;
  }
`;

export const ErrorCode = styled.div`
  font-size: 8rem;
  font-weight: 900;
  color: ${colors.primary};
  line-height: 1;
  margin-bottom: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-shadow: 0 4px 20px rgba(255, 190, 152, 0.3);
  
  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;

export const NotFoundIcon = styled.div`
  margin-bottom: 2rem;
`;

export const NotFoundTitle = styled.h1`
  margin: 0 0 1rem 0;
  font-size: 2.5rem;
  font-weight: 700;
  color: ${colors.quaternary};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  letter-spacing: -0.02em;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const NotFoundSubtitle = styled.h2`
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: ${colors.tertiary};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const NotFoundDescription = styled.p`
  margin: 0 0 2.5rem 0;
  color: ${colors.tertiary};
  font-size: 1rem;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
  
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const PrimaryButton = styled.button`
  background: ${colors.primary};
  color: ${colors.quaternary};
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: none;
  min-width: 160px;
  
  &:hover {
    background: ${colors.secondary};
    color: ${colors.quaternary};
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 190, 152, 0.4);
    border: 1px solid ${colors.primary};
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  background: ${colors.secondary};
  color: ${colors.quaternary};
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
  min-width: 160px;
  
  &:hover {
    background: rgba(0, 0, 0, 0.02);
    border-color: ${colors.primary};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

// Legacy component for backward compatibility
export const NotFoundWrapper = styled.div`
  padding: 1em;
  & p {
    padding: 1em 0;
  }
`; 